import React from "react"
import { graphql, StaticQuery } from "gatsby"
import Modal from "react-modal"
import { Form } from "react-final-form"
import isEmail from "validator/lib/isEmail"
import styled from "styled-components"
import { StyledForm } from "Styles"
import { theme } from "Theme"
import Config from "Data"
import { HeaderImage, FormHiddenFields, Link, FormDebug, LoadingSpinner, Utils } from "Components"
import { Recaptcha, Input, TextArea, Heading, Spacer } from "Components/FormElements"
import { loadReCaptcha } from "react-recaptcha-google"
const { fontSize } = theme

function ValidateEmail(email) {
  var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  if (email.match(validRegex)) {
    return true
  } else {
    return false
  }
}

const emailblockReg =
  /^([\w]+@(?!gmail.com)(?!yahoo.com)(?!ymail.com)(?!hotmail.com)(?!msn.com)(?!aol.com)(?!live.com)(?!icloud.com)(?!me.com)([\w-]+\.)+[\w-]{2,4})?$/

const Container = styled.div`
  position: relative;
  padding: 1rem 1rem 0;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 2rem 2rem 0;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const PrivacyLink = styled((props) => <Link {...props} />)`
  font-size: ${fontSize.smallish};
  padding: 1rem;
`

const Logo = styled.div`
  margin-top: -3rem;
  background: #fff;
  border-radius: ${theme.borderRadius.ui};
  box-shadow: ${theme.shadow.feature.small.default};
  border: 1px solid #ddd;
  z-index: 3;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 1rem;
  margin-bottom: 2rem;
  @media (min-width: ${theme.breakpoints.s}) {
    align-items: center;
  }
`

const StyledLink = styled((props) => <Link {...props} />)`
  text-decoration: underline;
`

const windowGlobal = typeof window !== "undefined" && window

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      loading: false,
      recaptcha: false,
    }
    this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this)
    this.verifyCallback = this.verifyCallback.bind(this)
  }

  componentDidMount() {
    loadReCaptcha()
    if (this.captchaObject) {
      this.captchaObject.reset()
      this.captchaObject.execute()
      // console.log("captchaObject.execute()")
    } else {
      // console.log("captchaObject NOT LOADED")
    }
  }

  verifyCallback(recaptchaToken) {
    this.setState({ ...this.state, recaptcha: true })
    // console.log("verifyCallback!")
  }

  onLoadRecaptcha() {
    // console.log("onLoadRecaptcha!")
    if (this.captchaObject) {
      this.captchaObject.reset()
      // console.log("onLoadRecaptcha After Reset!")
      this.captchaObject.execute()
    }
  }

  render() {
    const { props } = this
    const { sponsor, title, subtitle, banner, isOpen, closeModal, onAfterOpen, onRequestClose, onChangeInput } = props

    let sponsorData = sponsor ? { ...sponsor.node } : ""
    delete sponsorData.childFile

    let formData = {
      formName: "FormContactPartner",
      origin: windowGlobal ? windowGlobal.location.href : "",
      retURL: "/contact-partner-thank-you",
      country: windowGlobal.country,
      brand: Config.brand,
      sponsor: sponsorData,
      mailingList: "contact_partner_cxosync",
      rep: "",
    }

    const toggleLoading = (e) => {
      this.setState({ ...this.state, loading: false })
    }

    const resetRecaptcha = (e) => {
      this.setState({ ...this.state, recaptcha: false })
    }

    function postData(url = ``, data = {}) {
      return fetch(url, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
        referrer: "no-referrer",
        body: JSON.stringify(data),
      })
        .then((response) => {
          response
            .json()
            .then((data) => {
              resetRecaptcha()
              if (data.retURL) {
                windowGlobal.location = data.retURL
              } else {
                toggleLoading()
                onRequestClose()
              }
            })
            .catch(function (e) {
              console.error("handled the error")
              console.error(e)
            })
        })
        .catch((error) => console.error("Error:", error))
    }

    const onSubmit = async (values) => {
      console.log(JSON.stringify(values, 0, 2))
      this.setState({ loading: true })
      postData(Utils.endpoints.referee, values).catch((error) => console.error(error))
    }

    const handleChange = (e) => {
      formData[e.target.name] = e.target.value
      this.setState(formData)
    }

    return (
      <StaticQuery
        query={graphql`
          query {
            events: allGoogleSheetOverview2025(
              filter: { calendar: { eq: true } }
              sort: { order: DESC, fields: date }
            ) {
              totalCount
              edges {
                node {
                  id
                  brand
                  region
                  events
                  eventTitle
                  stateCity
                  date
                  eventSite
                  twitter
                  image
                  # childrenFile {
                  #   childImageSharp {
                  #     fluid(maxWidth: 480, quality: 90) {
                  #       ...GatsbyImageSharpFluid
                  #     }
                  #   }
                  # }
                }
              }
            }
          }
        `}
        render={(data) => {
          const { loading } = this.state

          return (
            <Modal
              id="modalContactPartner"
              contentLabel="modalContactPartner"
              closeTimeoutMS={400}
              isOpen={isOpen}
              onAfterOpen={onAfterOpen}
              onRequestClose={onRequestClose}
              shouldFocusAfterRender={true}
              shouldCloseOnOverlayClick={true}
              shouldCloseOnEsc={true}
              shouldReturnFocusAfterClose={true}>
              {!loading && (
                <>
                  <HeaderImage
                    title={sponsor ? sponsor.node.name : ""}
                    sponsorType=""
                    subtitle={sponsor ? sponsor.node.website : ""}
                    image={sponsor ? sponsor.node.childFile : ""}
                    sponsor={true}
                  />
                  <button className="btn-close" onClick={closeModal}>
                    X
                  </button>
                </>
              )}
              <Container>
                {loading && <LoadingSpinner />}
                {sponsor && (
                  <>
                    <p>
                      <small>{sponsor ? sponsor.node.description : ""}</small>
                    </p>
                    <p>
                      <small>
                        Learn more at:{" "}
                        <StyledLink
                          to={sponsor ? sponsor.node.website : ""}
                          title={sponsor.node.name}
                          track={"Visit Partner Site"}>
                          {sponsor.node.website}
                        </StyledLink>
                      </small>
                    </p>

                    <hr />
                    <Heading title="Get in touch:" />
                    <Form
                      initialValues={formData}
                      onSubmit={onSubmit}
                      validate={(values) => {
                        const errors = {}
                        if (!values.firstName) {
                          errors.firstName = "Required"
                        }
                        if (!values.lastName) {
                          errors.lastName = "Required"
                        }
                        if (!values.email) {
                          errors.email = "Required"
                        } else if (!isEmail(values.email)) {
                          errors.email = "Invalid email"
                        } else if (!ValidateEmail(values.email)) {
                          errors.email = "Not a Company email!"
                        }
                        if (!values.company) {
                          errors.company = "Required"
                        }
                        if (!this.state.recaptcha) {
                          errors.recaptcha = "Required"
                        }
                        return errors
                      }}
                      render={({ form, handleSubmit, reset, submitting, pristine, values }) => (
                        <>
                          <StyledForm className="form">
                            <FormHiddenFields hiddenData={formData} />

                            <Input
                              name="firstName"
                              label="First Name"
                              placeholder="First Name"
                              type="text"
                              className="firsthalfWidthElement"
                              required={true}
                            />
                            <Input
                              name="lastName"
                              label="Last Name"
                              placeholder="Last Name"
                              type="text"
                              className="lasthalfWidthElement"
                              required={true}
                            />
                            <Input
                              name="company"
                              label="Company"
                              placeholder="Company"
                              type="text"
                              className="firsthalfWidthElement"
                              required={true}
                            />
                            <Input
                              name="email"
                              label="Email (Corporate Only)"
                              placeholder="Your email"
                              className="lasthalfWidthElement"
                              type="email"
                              onBlur={handleChange}
                              required={true}
                            />
                            <TextArea
                              name="message"
                              label="Message"
                              placeholder="Message"
                              type="text"
                              className="messageElement"
                            />

                            <div className="fullWidthElement">
                              <Recaptcha
                                name="Recaptcha"
                                onloadCallback={this.onloadCallback}
                                verifyCallback={this.verifyCallback}
                              />
                            </div>

                            <Spacer />

                            <div className="buttonsWrapper">
                              <button
                                type="button"
                                className="btn"
                                onClick={form.reset}
                                data-gtm={`Form Contact Sponsor | Reset`}
                                disabled={submitting || pristine}>
                                Clear
                              </button>
                              <button
                                type="submit"
                                className="btn"
                                disabled={submitting || pristine}
                                onClick={handleSubmit}
                                data-gtm={`Form Contact Sponsor | Submit`}>
                                Submit
                              </button>
                            </div>
                            <div className="footerWrapper">
                              <PrivacyLink to={"/privacy/"} title={`Privacy policy`}>
                                Privacy policy
                              </PrivacyLink>
                            </div>
                          </StyledForm>

                          <FormDebug data={values}></FormDebug>
                        </>
                      )}
                    />
                  </>
                )}
              </Container>
            </Modal>
          )
        }}
      />
    )
  }
}
